import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Let’s Discuss Your Project</h2>
                        </div>
                        <p>At Tekrevol, we prioritize encouraging our clients to make informed decisions. As part of our commitment, we offer a complimentary consultation to kickstart your journey with us. We believe in transparency & aim to ensure that our clients have a clear understanding of the scope and potential of their projects before proceeding.  Let’s get started!</p>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;